const ARRAY_ITEM_TEMPLATES = {
  'seo.keywords': '',
  'services.items': { title: '', description: '', image: { url: '', alt: '' } },
  'usp.items': '',
  'testimonials.items': { name: '', quote: '' },
  'faq.items': { question: '', answer: '' },
  'openingHours.days': { day: '', opens: '', closes: '', closed: false },
  'media.gallery': { url: '', alt: '' }
};

const FIELD_LABELS = {
  enabled: 'Aktiv sektion',
  eyebrow: 'Eyebrow-text',
  galleryEnabled: 'Aktiv gallerisektion',
  galleryEyebrow: 'Galleri eyebrow-text',
  headerLogoOnly: 'Visa enbart logotyp i sidhuvud',
  logoWidth: 'Logotypbredd',
  imageRatio: 'Bild-ratio',
  headingFont: 'Rubriktypsnitt',
  bodyFont: 'Texttypsnitt',
  headerBackgroundColor: 'Bakgrund sidhuvud',
  mainBackgroundColor: 'Bakgrund main',
  footerBackgroundColor: 'Bakgrund footer',
  openingHours: 'Öppettider',
  opens: 'Öppnar',
  closes: 'Stänger',
  closed: 'Stängt',
  day: 'Dag',
  image: 'Bild'
};

function isPlainObject(value) {
  return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
}

export function deepEqual(a, b) {
  if (a === b) {
    return true;
  }

  if (Array.isArray(a) && Array.isArray(b)) {
    return a.length === b.length && a.every((item, index) => deepEqual(item, b[index]));
  }

  if (isPlainObject(a) && isPlainObject(b)) {
    const keys = Array.from(new Set([...Object.keys(a), ...Object.keys(b)]));
    return keys.every((key) => deepEqual(a[key], b[key]));
  }

  return false;
}

export function buildPatch(original, draft) {
  if (deepEqual(original, draft)) {
    return undefined;
  }

  if (Array.isArray(draft)) {
    return draft;
  }

  if (!isPlainObject(draft) || !isPlainObject(original)) {
    return draft;
  }

  const patch = {};
  const keys = Array.from(new Set([...Object.keys(original), ...Object.keys(draft)]));

  keys.forEach((key) => {
    const nextPatch = buildPatch(original[key], draft[key]);
    if (nextPatch !== undefined) {
      patch[key] = nextPatch;
    }
  });

  return Object.keys(patch).length ? patch : undefined;
}

export function setIn(value, path, nextValue) {
  if (!path.length) {
    return nextValue;
  }

  const [head, ...tail] = path;
  const clone = Array.isArray(value) ? [...value] : { ...(value || {}) };
  clone[head] = setIn(clone[head], tail, nextValue);
  return clone;
}

export function getIn(value, path) {
  return path.reduce((current, segment) => (current == null ? current : current[segment]), value);
}

export function removeAt(array, index) {
  return array.filter((_, itemIndex) => itemIndex !== index);
}

export function toLabel(value) {
  if (FIELD_LABELS[value]) {
    return FIELD_LABELS[value];
  }

  return String(value)
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/[_-]/g, ' ')
    .replace(/\b\w/g, (match) => match.toUpperCase());
}

export function fieldUsesTextarea(key) {
  return /description|body|headline|subheadline|quote|answer|address|copyright|tagline/i.test(key);
}

export function getArrayTemplate(path) {
  return structuredClone(ARRAY_ITEM_TEMPLATES[path] ?? '');
}

export function slugify(value) {
  return String(value || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function resolveSiteAssetUrl(site, value) {
  if (!value) {
    return '';
  }

  if (/^(https?:)?\/\//.test(value) || value.startsWith('data:')) {
    return value;
  }

  if (!site?.repo_owner || !site?.repo_name || !site?.branch) {
    return value;
  }

  return `https://raw.githubusercontent.com/${site.repo_owner}/${site.repo_name}/${site.branch}/${value.replace(/^\//, '')}`;
}

export function readFileAsDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || ''));
    reader.onerror = () => reject(new Error('Kunde inte läsa filen.'));
    reader.readAsDataURL(file);
  });
}
